module.exports = __webpack_public_path__ + "static/media/tamplate.13f9453f.png";